export default __webpack_public_path__ + "static/media/element_spec_61.c66e6055.jpg";